import * as types from 'store/mutation-types'
import {setLocalStore,getLocalStore,removeLocalStore} from 'util/util'

// initial state
const state = {
  user: getLocalStore('user') || '',
  username: getLocalStore('username') || '',
  userimg: getLocalStore('userimg') || '',
  accesstoken: getLocalStore('accesstoken') || '',
  groupid: getLocalStore('groupid') || '',
  admin: getLocalStore('admin') || '',
  tokentimer: getLocalStore('tokentimer') || '',
  status: '',
  userId:getLocalStore('userId') || '',
  levv:'',
  licenceId:''
}


// actions
const actions = {
	//用户登录
  usersignin ({ commit }, user) {
    commit(types.USER_SIGNIN, user)
  },
  //用户退出
  usersignout ({ commit }) {
    commit(types.USER_SIGNOUT)
  },
  //保存用户名
  setusername ({ commit}, username) {
    commit(types.SET_USERNAME, username)
  },
  //删除用户名
  removeusername ({ commit }) {
    commit(types.REMOVE_USERNAME)
  },
  //保存用户头像
  setuserimg ({ commit}, userimg) {
    commit(types.SET_USERIMG, userimg)
  },
  //删除用户头像
  removeuserimg ({ commit}) {
    commit(types.REMOVE_USERIMG)
  },
  //保存token
  settoken ({ commit}, token) {
    commit(types.SET_TOKEN, token)
  },
  //删除token
  removetoken ({ commit }) {
    commit(types.REMOVE_TOKEN)
  },
  //保存group
  setgroup ({ commit}, group) {
    commit(types.SET_GROUP, group)
  },
  //删除group
  removegroup ({ commit }) {
    commit(types.REMOVE_GROUP)
  },
  //保存admin
  setadmin ({ commit}, admin) {
    commit(types.SET_ADMIN, admin)
  },
  //删除admin
  removeadmin ({ commit }) {
    commit(types.REMOVE_ADMIN)
  },
   //删除tokentimer
  savetokentimer ({ commit }, name) {
    commit(types.SET_TOKENTIMER,name)
  },
  //保存全部用户信息
  saveall ({ commit }, info) {
    commit(types.SET_ALL,info)
  },
  //删除全部用户信息
  removeall ({ commit }) {
    commit(types.REMOVE_ALL)
  },
  //保存状态
  setstatus ({ commit}, status) {
    commit(types.SET_STATUS, status)
  },
  saveUserInfo({commit},obj){
  	commit(types.SAVE_LEVEL,obj)
  }
}

// mutations
const mutations = {
	//用户登录
  [types.USER_SIGNIN] (state, user) {
     	setLocalStore('user', JSON.stringify(user))
      state.user=user
  },
  //用户退出
  [types.USER_SIGNOUT] (state) {
     	removeLocalStore('user')
      state.user=''
  },
  //保存用户名
  [types.SET_USERNAME] (state, username) {
  		setLocalStore('username', username)
  		state.username=username
  },
  //删除用户名
  [types.REMOVE_USERNAME] (state) {
  		removeLocalStore('username')
  		state.username=''
  },
   //保存用户头像
  [types.SET_USERIMG] (state, userimg) {
  		setLocalStore('userimg', userimg)
  		state.userimg=userimg
  },
  //删除用户头像
  [types.REMOVE_USERIMG] (state) {
  		removeLocalStore('userimg')
  		state.userimg=''
  },
  //保存token
  [types.SET_TOKEN] (state, token) {
  		setLocalStore('accesstoken', token)
  		state.accesstoken=token
  },
  //删除token
  [types.REMOVE_TOKEN] (state) {
  		removeLocalStore('accesstoken')
  		state.accesstoken=''
  },
  //保存group
  [types.SET_GROUP] (state, group) {
  		setLocalStore('groupid', group)
  		state.groupid=group
  },
  //删除group
  [types.REMOVE_GROUP] (state) {
  		removeLocalStore('groupid')
  		state.groupid=''
  },
   //保存admin
  [types.SET_ADMIN] (state, admin) {
  		setLocalStore('admin', admin)
  		state.admin=admin
  },
  //删除admin
  [types.REMOVE_ADMIN] (state) {
  		removeLocalStore('admin')
  		state.admin=''
  },
  //保存tokentimer
  [types.SET_TOKENTIMER] (state, name) {
  		setLocalStore('tokentimer', name)
  		state.tokentimer=name
  },
   //保存全部用户信息
  [types.SET_ALL] (state, info) {
  		setLocalStore('user', JSON.stringify(info.user))
      state.user=info.user
      setLocalStore('username', info.username)
  		state.username=info.username
  		setLocalStore('userimg', info.userimg)
  		state.userimg=info.userimg
  		setLocalStore('groupid', info.group)
  		state.groupid=info.group
  		setLocalStore('admin', info.admin)
  		state.admin=info.admin
  		setLocalStore('accesstoken', info.token)
  		state.accesstoken=info.token
  		state.status=''
  		setLocalStore('userId',info.userId)
      state.userId = info.userId
  },
  //删除全部用户信息
  [types.REMOVE_ALL] (state) {
  		removeLocalStore('user')
      state.user=''
      removeLocalStore('username')
  		state.username=''
  		removeLocalStore('userimg')
  		state.userimg=''
  		removeLocalStore('groupid')
  		state.groupid=''
  		removeLocalStore('admin')
  		state.admin=''
  		removeLocalStore('accesstoken')
      state.accesstoken=''
      state.levv = ''
  },
  //保存状态
  [types.SET_STATUS] (state, status) {
  		state.status=status
  },
  [types.SAVE_LEVEL](state,obj){
      state.levv = obj.levv;
      state.licenceId = obj.licenceId
  }
}

export default {
  state,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js